import React from 'react';
import { WhatsAppCta } from './WhatsAppCta';
import { reunitedPhotos } from '../data/testimonials';
export function FeaturedTestimonial() {
  return <section className="bg-ink px-5 py-16 lg:px-8 lg:py-24" data-id="element-39" data-mp="3q8x8nxulfy0f">
      <div className="mx-auto max-w-3xl" data-id="element-40" data-mp="3v2rourazpuur">
        <img src={reunitedPhotos} alt="Parejas y familias que volvieron a estar juntas" loading="lazy" className="w-full rounded-2xl border border-gold/20 object-cover" data-id="element-41" data-mp="3v3tblt1dc5sb" />

        <blockquote className="mt-10 border-l-2 border-gold/50 pl-6 lg:pl-10" data-id="element-42" data-mp="37c5q5qmvlmxf">
          <p className="font-display text-2xl leading-snug text-gold-soft sm:text-3xl" data-id="element-43" data-mp="37e8jokn8ly6w">
            “Una ex–amiga se metió en nuestra relación y usó magia negra para
            manipular la mente de mi pareja.”
          </p>

          <div className="mt-6 space-y-4 text-base leading-relaxed text-white/70" data-id="element-44" data-mp="rl9rxewra894">
            <p data-id="element-45" data-mp="wk4bwk6gm2ut">
              Hoy, con fe, quiero agradecer al Dr. Solución porque hemos llegado
              muy lejos. Siempre fuimos una pareja muy unida, pero pasamos por
              una mala experiencia donde casi, casi nuestra relación se rompió.
            </p>
            <p data-id="element-46" data-mp="1sedz9hsiv5cm">
              Él empezó a comportarse extraño y a volverse cada vez más
              agresivo, hasta que conocí al Maestro, quien nos brindó su apoyo,
              conocimiento y experiencia. Gracias a eso logramos superar esa
              pesadilla.
            </p>
            <p data-id="element-47" data-mp="1dhwrf0jjk8ut">
              Seguimos juntos y nuestra relación se hizo más fuerte. Sin duda
              les recomiendo que busquen la ayuda del Maestro y, con fe y
              confianza, dejen todo en sus manos.
            </p>
          </div>

          <footer className="mt-7" data-id="element-48" data-mp="zp72oocmopu0">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-49" data-mp="zq8fax9alkdu">
              Testimonio real de una pareja reunida
            </p>
          </footer>

          <div className="mt-8" data-id="element-50" data-mp="pq98p5wfo43m">
            <WhatsAppCta label="Quiero recuperar mi amor" message="Hola Maestro, quiero recuperar a mi pareja. ¿Cómo empezamos?" data-id="element-51" data-mp="prav26iwgd0n" />
          </div>
        </blockquote>
      </div>
    </section>;
}